export default __webpack_public_path__ + "static/media/hands-on.ca5d1b40.svg";